import * as React from "react";
import {ReactElement, useState} from "react";
import {connect} from "react-redux";
import {Box, styled, Typography} from "@mui/material";
import {IPageProps} from "../interfaces/components/props/IPageProps";
import {setNewSeeds} from "../redux/slice/seedSlice";
import {RootState} from "../redux/store";
import {ITheme} from "../interfaces/themes/ITheme";

const QuoteDiv = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    placeContent: 'center',
     height: 'auto',
    [theme.breakpoints.only('xs')]: {
        padding: `${theme.spacing(4)} ${theme.spacing(1)}`,
    },
    [theme.breakpoints.only('sm')]: {
        padding: `${theme.spacing(6)} ${theme.spacing(1)}`,
    },
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(6),
    },
}));

const QuoteTexts = styled(Box)(({theme}) => ({
    width: 'auto',
    display: 'grid',
    alignContent: 'center',
    placeItems: 'center',
    textAlign: 'center',
    overflow: 'auto',
    cursor: 'pointer',
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[1],

    [theme.breakpoints.only('sm')]: {
        padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2),
    },

    backgroundColor: `${theme.palette.secondary.main}99`,
    '&:hover': {
        backgroundColor: `${theme.palette.secondary.main}DD`,
    },
    '&:active': {
        backgroundColor: `${theme.palette.secondary.main}`,
    },

}));

const QuoteText = styled(Typography)(({theme}) => ({
    fontStyle: 'italic',
    overflowWrap: 'break-word',
    minWidth: 'fit-content',
}));

const QuoterText = styled(Typography)(({theme}: {theme: ITheme}) => ({
    color: theme.palette.text.quaternary,
    paddingTop: theme.spacing(1),
    fontStyle: 'italic',
    opacity: 0.95,
    fontSize: 22,
}));


interface IProps extends IPageProps {
    seed1: number;
    seed2: number;
    seed3: number;
    setNewSeeds: () => void;
}

function Quotes(props: IProps): ReactElement {
    const {languageTokens, seed1, seed2, seed3, setNewSeeds} = props;

    // Quote
    const [index1, setIndex] = useState<number>(Math.floor(Math.random() * languageTokens.quotes.length));
    let quote: string = languageTokens.quotes[index1];
    const quoteParts: string[] = quote.split('\n');

    // Quoter Prefix
    const index2 = seed2 % languageTokens.quoterPrefix.length
    const quoterPrefix = languageTokens.quoterPrefix[index2];

    // Quoter
    const index3 = seed3 % languageTokens.quoter.length
    const quoter: string = languageTokens.quoter[index3];

    const handleSetNewSeeds = () => {
        const newIndex1 = (index1 + 1) % languageTokens.quotes.length;
        setIndex(newIndex1);
        setNewSeeds();
    }

    return (
        <QuoteDiv id={'Quotes'}>
            <QuoteTexts
                id={'QuoteTexts'}
                onClick={handleSetNewSeeds}
            >
                {quoteParts.map(part =>
                    <QuoteText
                        key={part}
                        variant={"h6"}
                    >{part}
                    </QuoteText>
                )}
                <QuoterText
                >{`${quoterPrefix}${quoter}, ${new Date().getFullYear()}`}
                </QuoterText>
            </QuoteTexts>
        </QuoteDiv>
    );
}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
    seed1: state.seed.seed1,
    seed2: state.seed.seed2,
    seed3: state.seed.seed3,
});

const mapActionsToProps = {
    setNewSeeds,
};

export default connect(mapStateToProps, mapActionsToProps)(Quotes);
